/**
 * @flow
 * @relayHash f2b32a99a8859ddba53706e8432d048b
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type PaginatedShipmentsContainer_shipments$ref = any;
export type ShipmentSortField = "ACTUAL_SHIP_DATE" | "CARRIER_NAME" | "CREATED_AT" | "CUSTOMER" | "ESTIMATED_SHIP_DATE" | "ORDER_NUMBER" | "SHIPMENT_NUMBER" | "STATUS" | "UPDATED_AT";
export type ShipmentStatus = "DELIVERED" | "DRAFT" | "READY" | "SHIPPED";
export type SortDirection = "ASC" | "DESC";
export type ShipmentSort = {|
  field: ShipmentSortField,
  direction: SortDirection,
|};
export type PaginatedShipmentsContainerQueryVariables = {|
  count: number,
  cursor?: ?string,
  search?: ?string,
  sortBy?: ?ShipmentSort,
  statuses?: ?$ReadOnlyArray<ShipmentStatus>,
  customerIds?: ?$ReadOnlyArray<string>,
  orderIds?: ?$ReadOnlyArray<string>,
  estimatedShipDateStart?: ?any,
  estimatedShipDateEnd?: ?any,
  actualShipDateStart?: ?any,
  actualShipDateEnd?: ?any,
|};
export type PaginatedShipmentsContainerQueryResponse = {|
  +$fragmentRefs: PaginatedShipmentsContainer_shipments$ref
|};
export type PaginatedShipmentsContainerQuery = {|
  variables: PaginatedShipmentsContainerQueryVariables,
  response: PaginatedShipmentsContainerQueryResponse,
|};
*/


/*
query PaginatedShipmentsContainerQuery(
  $count: Int!
  $cursor: String
  $search: String
  $sortBy: ShipmentSort
  $statuses: [ShipmentStatus!]
  $customerIds: [ID!]
  $orderIds: [ID!]
  $estimatedShipDateStart: Date
  $estimatedShipDateEnd: Date
  $actualShipDateStart: Date
  $actualShipDateEnd: Date
) {
  ...PaginatedShipmentsContainer_shipments_1BJCWc
}

fragment PaginatedShipmentsContainer_shipments_1BJCWc on Query {
  shipments(first: $count, after: $cursor, search: $search, sortBy: $sortBy, statuses: $statuses, customerIds: $customerIds, orderIds: $orderIds, estimatedShipDateStart: $estimatedShipDateStart, estimatedShipDateEnd: $estimatedShipDateEnd, actualShipDateStart: $actualShipDateStart, actualShipDateEnd: $actualShipDateEnd) {
    edges {
      cursor
      ...ShipmentsTable_shipmentEdges
      node {
        __typename
        id
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment ShipmentsTable_shipmentEdges on ShipmentEdge {
  node {
    id
    shipmentNumber
    status
    carrierName
    trackingNumber
    shippingMethod
    estimatedShipDate
    actualShipDate
    estimatedDeliveryDate
    actualDeliveryDate
    notes
    order {
      id
      orderNumber
    }
    customer {
      id
      name
    }
    createdAt
    updatedAt
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "count",
    "type": "Int!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "cursor",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "search",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "sortBy",
    "type": "ShipmentSort",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "statuses",
    "type": "[ShipmentStatus!]",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "customerIds",
    "type": "[ID!]",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "orderIds",
    "type": "[ID!]",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "estimatedShipDateStart",
    "type": "Date",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "estimatedShipDateEnd",
    "type": "Date",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "actualShipDateStart",
    "type": "Date",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "actualShipDateEnd",
    "type": "Date",
    "defaultValue": null
  }
],
v1 = {
  "kind": "Variable",
  "name": "actualShipDateEnd",
  "variableName": "actualShipDateEnd"
},
v2 = {
  "kind": "Variable",
  "name": "actualShipDateStart",
  "variableName": "actualShipDateStart"
},
v3 = {
  "kind": "Variable",
  "name": "customerIds",
  "variableName": "customerIds"
},
v4 = {
  "kind": "Variable",
  "name": "estimatedShipDateEnd",
  "variableName": "estimatedShipDateEnd"
},
v5 = {
  "kind": "Variable",
  "name": "estimatedShipDateStart",
  "variableName": "estimatedShipDateStart"
},
v6 = {
  "kind": "Variable",
  "name": "orderIds",
  "variableName": "orderIds"
},
v7 = {
  "kind": "Variable",
  "name": "search",
  "variableName": "search"
},
v8 = {
  "kind": "Variable",
  "name": "sortBy",
  "variableName": "sortBy"
},
v9 = {
  "kind": "Variable",
  "name": "statuses",
  "variableName": "statuses"
},
v10 = [
  (v1/*: any*/),
  (v2/*: any*/),
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "cursor"
  },
  (v3/*: any*/),
  (v4/*: any*/),
  (v5/*: any*/),
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "count"
  },
  (v6/*: any*/),
  (v7/*: any*/),
  (v8/*: any*/),
  (v9/*: any*/)
],
v11 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "PaginatedShipmentsContainerQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "FragmentSpread",
        "name": "PaginatedShipmentsContainer_shipments",
        "args": [
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "kind": "Variable",
            "name": "count",
            "variableName": "count"
          },
          {
            "kind": "Variable",
            "name": "cursor",
            "variableName": "cursor"
          },
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/)
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "PaginatedShipmentsContainerQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "shipments",
        "storageKey": null,
        "args": (v10/*: any*/),
        "concreteType": "ShipmentConnection",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "ShipmentEdge",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "cursor",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "Shipment",
                "plural": false,
                "selections": [
                  (v11/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "shipmentNumber",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "status",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "carrierName",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "trackingNumber",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "shippingMethod",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "estimatedShipDate",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "actualShipDate",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "estimatedDeliveryDate",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "actualDeliveryDate",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "notes",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "order",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Order",
                    "plural": false,
                    "selections": [
                      (v11/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "orderNumber",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "customer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Customer",
                    "plural": false,
                    "selections": [
                      (v11/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "name",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "createdAt",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "updatedAt",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "__typename",
                    "args": null,
                    "storageKey": null
                  }
                ]
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "pageInfo",
            "storageKey": null,
            "args": null,
            "concreteType": "PageInfo",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "endCursor",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "hasNextPage",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      },
      {
        "kind": "LinkedHandle",
        "alias": null,
        "name": "shipments",
        "args": (v10/*: any*/),
        "handle": "connection",
        "key": "PaginatedShipmentsContainer_shipments",
        "filters": []
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "PaginatedShipmentsContainerQuery",
    "id": null,
    "text": "query PaginatedShipmentsContainerQuery(\n  $count: Int!\n  $cursor: String\n  $search: String\n  $sortBy: ShipmentSort\n  $statuses: [ShipmentStatus!]\n  $customerIds: [ID!]\n  $orderIds: [ID!]\n  $estimatedShipDateStart: Date\n  $estimatedShipDateEnd: Date\n  $actualShipDateStart: Date\n  $actualShipDateEnd: Date\n) {\n  ...PaginatedShipmentsContainer_shipments_1BJCWc\n}\n\nfragment PaginatedShipmentsContainer_shipments_1BJCWc on Query {\n  shipments(first: $count, after: $cursor, search: $search, sortBy: $sortBy, statuses: $statuses, customerIds: $customerIds, orderIds: $orderIds, estimatedShipDateStart: $estimatedShipDateStart, estimatedShipDateEnd: $estimatedShipDateEnd, actualShipDateStart: $actualShipDateStart, actualShipDateEnd: $actualShipDateEnd) {\n    edges {\n      cursor\n      ...ShipmentsTable_shipmentEdges\n      node {\n        __typename\n        id\n      }\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment ShipmentsTable_shipmentEdges on ShipmentEdge {\n  node {\n    id\n    shipmentNumber\n    status\n    carrierName\n    trackingNumber\n    shippingMethod\n    estimatedShipDate\n    actualShipDate\n    estimatedDeliveryDate\n    actualDeliveryDate\n    notes\n    order {\n      id\n      orderNumber\n    }\n    customer {\n      id\n      name\n    }\n    createdAt\n    updatedAt\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'd3c090cb32f256c713442095327a2ab0';
module.exports = node;
